import React, { useCallback } from "react";
import cn from "classnames";

import Validation from "../Validation";
import Label from "../Label";

import { StyledRadio, RadioOption, Marker, Center } from "./styles";
import { IProps } from "./interfaces";

const Radio = <T extends string | number>({ label, disabled, validation, required, options, value, name, onChange, direction = 'column' }: IProps<T>) => {
    const change = useCallback((value: T) => {
        if (disabled) return;
        onChange({
            target: {
                type: "radio",
                name,
                value,
            },
        });
    }, [onChange, name, disabled]);

    return (
        <StyledRadio className={cn()}>
            {label && (
                <Label disabled={disabled} required={required}>
                    {label}
                </Label>
            )}
            {validation && <Validation validation={validation} />}
            <div style={{ ...(direction === 'row' && {
                display: 'flex',
                gap: 12,
            })}}>
                {options.map(option => (
                    <RadioOption
                        className={disabled ? "Disabled" : ""}
                        key={option.value}
                        onClick={() => change(option.value)}
                    >
                        <Marker className={disabled ? "Disabled" : ""} selected={option.value === value}>
                            <Center className={disabled ? "Disabled" : ""} selected={option.value === value}></Center>
                        </Marker>
                        {option.label}
                    </RadioOption>
                ))}
            </div>
        </StyledRadio>
    );
}

export default Radio;
